import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsTaskAddComp from "./Component/TsTaskAddComp"


const TsTaskAdd =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsTaskAddComp />
        </div>
        <Footer />
        </>
    )
}

export default TsTaskAdd